import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AlertService, LoadingService } from '@shared/src/public-api';
import { BaseController } from '../../base.controller';
import { IntegrationBackOfficeDto } from './IntegrationBackOfficeDto';
import { IntegrationBackOfficeFilterDto } from './IntegrationBackOfficeFilterDto';
import { FileUpDownLoadDto } from '@shared/src/dtos/base/FileUpDownLoadDto';
@Injectable({
    providedIn: 'root',
})
export class IntegrationBackOfficeController extends BaseController {

    private base = '/internal/integrationbackoffice'
    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        protected router: Router,
        @Inject('LoadingService') protected loadingService: LoadingService) {
        super(http, alertService, translateService, loadingService, router);

    }
    public getInitialIntegrationBackOffice(): Observable<IntegrationBackOfficeDto> {
        return this.getBusy(this.base + "/");
    }
    public getIntegrationBackOffice(filter: IntegrationBackOfficeFilterDto): Observable<IntegrationBackOfficeDto> {
        return this.putBusy(this.base + "/", filter, "");
    }
    public action(filter: IntegrationBackOfficeFilterDto): Observable<FileUpDownLoadDto> {
        return this.putBusy(this.base + "/action", filter, "");
    }

}